var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmailStatistics = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,24.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140 220 c0 -13 -7 -20 -20 -20 -11 0 -20 -7 -20 -15 0 -8 -9 -15 -20 -15 -15 0 -20 -7 -20 -25 0 -19 -4 -23 -17 -18 -10 4 -3 -6 16 -22 l34 -29 -34 -29 c-19 -16 -25 -24 -13 -19 11 6 26 17 33 25 15 19 64 16 88 -4 10 -9 25 -19 33 -24 8 -4 0 6 -19 22 l-34 29 34 29 c19 16 26 26 17 22 -16 -6 -18 1 -18 53 0 53 -2 60 -20 60 -13 0 -20 -7 -20 -20z m30 -40 c0 -27 -4 -50 -10 -50 -5 0 -10 23 -10 50 0 28 5 50 10 50 6 0 10 -22 10 -50z m-40 -20 c0 -16 -4 -30 -10 -30 -5 0 -10 14 -10 30 0 17 5 30 10 30 6 0 10 -13 10 -30z m-40 -15 c0 -8 -4 -15 -10 -15 -5 0 -10 7 -10 15 0 8 5 15 10 15 6 0 10 -7 10 -15z m65 -50 c-16 -14 -32 -25 -35 -25 -3 0 -18 11 -35 25 l-30 24 65 0 65 0 -30 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 75 l0 -75 110 0 110 0 0 75 c0 71 -1 75 -22 75 -20 0 -21 -1 -4 -13 13 -10 17 -24 14 -67 l-3 -55 -95 0 -95 0 -3 55 c-3 43 1 57 14 67 17 12 16 13 -4 13 -21 0 -22 -4 -22 -75z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmailStatistics);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email-statistics.904f8b90d72bed4d945cd5d79a3b1003.svg";